// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"2a5446ca","34":"9d408cbe","425":"422d57ae","510":"b1e653a0","532":"414d80e7","633":"e0cb317e","922":"fdd50673","937":"4034c6bf","972":"420beeb7"}[chunkId] + ".chunk.js";
};